<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2022-07-03 00:42:29
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2022-07-19 18:31:43
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\termPage\interaction\components\userReviews\index.vue
-->
<!-- 报到记录 -->
<template>
    <div class='userReviews'>
        <!-- 筛选 -->
        <div class="serach">
            <div class="left">
                <el-select v-model="selectvalue" size='small' placeholder="请选择搜索内容"
                    style="width: 166px;margin-right:20px" @change="searchChange">
                    <el-option label="真实姓名" :value="1"></el-option>
                    <el-option label="用户名" :value="2"></el-option>
                    <el-option label="对应医生" :value="3"></el-option>
                    <el-option label="报到时间" :value="4"></el-option>
                </el-select>
                <el-input v-if="selectvalue != 4" :placeholder="placeholderChange" style="width: 166px;margin-right:20px" size='small'
                    v-model="inputvalue">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-date-picker v-if="selectvalue == 4" style="margin-right: 20px;" size="small" value-format="yyyy-MM-dd" v-model="times" :default-time="['00:00:00']"
                    clearable align="center" popper-class="popper-class" type="daterange" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期" @change="timeChange">
                </el-date-picker>
                <el-button type="primary" size='small' style="background:#1A7BFC;border-color:#1A7BFC" @click="getData()">搜索</el-button>
                <el-button size='small' @click="resectData()">重置</el-button>
            </div>
            <div class="right">
                <el-button type="primary" size='small' style="background:#1A7BFC;border-color:#1A7BFC"
                    @click="toStatistics()">数据统计</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <div class="table-container" v-loading="loading">
            <el-table id="tableInfo" :data="tableData" style="width: 100%">
                <el-table-column prop="id" label="ID" align="center"></el-table-column>
                <el-table-column prop="patientUsername" label="用户名" align="center"></el-table-column>
                <el-table-column prop="patientRealName" label="真实姓名" align="center"></el-table-column>
                <el-table-column prop="refName" label="对应医生" align="center"></el-table-column>
                <el-table-column prop="createTime" label="报道时间" align="center"></el-table-column>
            </el-table>
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="searchForm.current" :page-size="searchForm.size"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { patientOnboardPage } from '../../api/index.js'
export default {
    data() {
        //这⾥存放数据
        return {
            loading:false,
            times:[],
            placeholderChange: "请输入真实姓名",
            selectvalue: 1,
            inputvalue: '',
            searchForm: {
                startTime: null,//对应开始时间
                endTime: null,//对应结束时间
                username: null,//用户名
                realName: null,//真实姓名
                doctorName: null,//对应医生
                current: 1,//页数
                size: 10,//每页多少条
            },
            total: 0,//每页10条
            tableData: [],
            viewDetailDialog: false,//查看详情弹窗
            detailForm: {},
        };
    },
    //监听属性类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //⽅法集合
    methods: {
        resectData(){
            this.searchForm= {
                startTime: null,//对应开始时间
                endTime: null,//对应结束时间
                username: null,//用户名
                realName: null,//真实姓名
                doctorName: null,//对应医生
                current: 1,//页数
                size: 10,//每页多少条
            }
            this.times = [];
            this.inputvalue = '';
            this.selectvalue = 1;
            this.getData();
        },
        //搜索条件变更
        searchChange(e) {//1=真实姓名;2=用户名;3=对应医生;4=对应时间
            this.searchForm = {
                startTime: null,//对应开始时间
                endTime: null,//对应结束时间
                username: null,//用户名
                realName: null,//真实姓名
                doctorName: null,//对应医生
            }
            if (e == 1) {
                this.placeholderChange = '请输入真实姓名';
            } else if (e == 2) {
                this.placeholderChange = '请输入用户名';
            } else if (e == 3) {
                this.placeholderChange = '请输入对应医生';
            } else if (e == 4) {
                this.placeholderChange = '';
            }
        },
        //获取列表数据
        getData(){
            this.loading = true
            if (this.selectvalue == 1) {
                this.searchForm.realName = this.inputvalue;
            } else if (this.selectvalue == 2) {
                this.searchForm.username = this.inputvalue;
            } else if (this.selectvalue == 3) {
                this.searchForm.doctorName = this.inputvalue;
            } else if (this.selectvalue == 4) {
                this.placeholderChange = '';
            }
            this.searchForm.startTime = this.times[0] ? this.times[0] + ' ' + '00:00:00' : null;
            this.searchForm.endTime = this.times[1] ? this.times[1] + ' ' + '23:59:59' : null;
            patientOnboardPage({...this.searchForm}).then(res=>{
                this.total = res.data.total;
                this.tableData = res.data.records;
                this.loading = false;
            })
        },
        //跳转数据统计
        toStatistics() {
            this.$router.push('/termPage/statistics')
        },
        //分页
        handleSizeChange(e) {
            this.searchForm.size = e
            this.getData()
        },
        handleCurrentChange(e) {
            this.searchForm.current = e
            this.getData()
        },
        //选择时间
        timeChange(e){
            this.searchForm.startTime = e[0]
            this.searchForm.endTime = e[1]
        },
    },
    //⽣命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //⽣命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    //beforeCreate() {}, //⽣命周期 - 创建之前
    //beforeMount() {}, //⽣命周期 - 挂载之前
    //beforeUpdate() {}, //⽣命周期 - 更新之前
    //updated() {}, //⽣命周期 - 更新之后
    //beforeDestroy() {}, //⽣命周期 - 销毁之前
    //destroyed() {}, //⽣命周期 - 销毁完成
    //activated() {}, //如果页⾯有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped lang="less">
@import './index.less';
</style>